export enum UtmCampaign {
  CASH_INSTALLMENTS_LANDING = 'inst',
}
